<div class="more-filter-body">
    <div
        *ngFor="let control of moreFiltersControls; odd as isOdd"
        class="filter-grid"
        [ngClass]="{ 'right': isOdd }"
    >
        <div
            dynamicField
            [group]="formGroup"
            [config]="control"
            [value]="control.value"
        >
        </div>
    </div>
</div>

<div class="footer">
    <button
        class="btn btn-default"
        type="button"
        [attr.aria-label]="'events students.Clear More Filters' | translate"
        (click)="clear()"
    >
        {{ 'misc.Clear' | translate }}
    </button>

    <button
        class="btn btn-default ml-2"
        type="button"
        [attr.aria-label]="'events students.Cancel More Filters' | translate"
        (click)="cancel()"
    >
        {{ 'misc.Cancel' | translate }}
    </button>

    <button
        class="btn btn_primary ml-2"
        type="button"
        [attr.aria-label]="'events students.Apply More Filters' | translate"
        (click)="apply()"
    >
        {{ 'misc.Apply' | translate }}
    </button>
</div>
